import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/home';
import Propertieslist from './pages/Properties-list';
import Propertydetails from './pages/property-details';
import Errorr from './pages/error';




const Paths = () => {
    return ( 
        <>
            <BrowserRouter>
                <Routes>
                    <Route path='/' element={<Home/>} />
                    <Route path='/Propertieslist' element={<Propertieslist/>}/>
                    <Route path='/Propertydetails' element={<Propertydetails/>}/>
                    <Route path='*' element={<Errorr/>}/>                   
                </Routes>
            </BrowserRouter>
        </>
     );
}
 
export default Paths;